import React from 'react';

import { useTranslation } from 'react-i18next';

import Footer from '../../Components/Footer';
import Header from '../../Components/Header';

import './style.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='PrivacyPolicy'>
      <Header />
      <main className='PrivacyPolicy__main'>
        <div className='PrivacyPolicy__container'>
          <div className='PrivacyPolicy__header'>
            <h1 className='PrivacyPolicy__title'>{t('privacyPolicy.title')}</h1>
            <h2 className='PrivacyPolicy__site-title'>
              {t('privacyPolicy.siteTitle')}
            </h2>
            <p className='PrivacyPolicy__version'>{t('privacyPolicy.version')}</p>
            <p className='PrivacyPolicy__intro'>{t('privacyPolicy.intro')}</p>
          </div>

          <div className='PrivacyPolicy__content'>
            {/* 1. Data Controller */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.dataController.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.dataController.content')}
              </p>
            </section>

            {/* 2. Data Scope */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.dataScope.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.dataScope.content')}
              </p>
            </section>

            {/* 3. Legal Basis */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.legalBasis.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.legalBasis.content')}
              </p>
            </section>

            {/* 4. Voluntary Data */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.voluntaryData.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.voluntaryData.content')}
              </p>
            </section>

            {/* 5. Data Recipients */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.dataRecipients.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.dataRecipients.content')}
              </p>
            </section>

            {/* 6. Transfer to Third Countries */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.transferToThirdCountries.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.transferToThirdCountries.content')}
              </p>
            </section>

            {/* 7. Data Retention */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.dataRetention.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.dataRetention.content')}
              </p>
            </section>

            {/* 8. User Rights */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.userRights.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.userRights.content')}
              </p>
            </section>

            {/* 9. Complaint Right */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.complaintRight.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.complaintRight.content')}
              </p>
            </section>

            {/* 10. Cookies */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.cookies.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.cookies.content')}
              </p>
            </section>

            {/* 11. Server Logs */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.serverLogs.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.serverLogs.content')}
              </p>
            </section>

            {/* 12. Profiling */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.automatedDecisions.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.automatedDecisions.content')}
              </p>
            </section>

            {/* 13. Processor (B2B) */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.processor.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.processor.content')}
              </p>
            </section>

            {/* 14. Policy Changes */}
            <section className='PrivacyPolicy__section'>
              <h3 className='PrivacyPolicy__section-title'>
                {t('privacyPolicy.policyChanges.title')}
              </h3>
              <p className='PrivacyPolicy__section-text'>
                {t('privacyPolicy.policyChanges.content')}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
